import React from 'react';
import './Politique.css'; 

const Politique = () => {
  return (

    <div className='cookie-body'>

    <div className="politique-container">
      <h1>Politique de Confidentialité</h1>
      <br></br>

      <h1>Terme modifié: 30 avril 2025</h1>
      <br></br>

  {/*     <h1>
        Cette politique de confidentialité explique comment nous collectons, utilisons et protégeons vos informations.
      </h1> 
      <br></br>
      */}

      <h2>
       Nous respectons votre vie privée.
      <br></br>
       Nous n'utilisons pas Google Analytics ni aucun outil de suivi des informations utilisateur. 
       Nous utilisons des services tiers qui peuvent collecter des données pour assurer le bon fonctionnement du site.
        
      </h2>
     

      <h1>Services Firebase que nous utilisons et informations collectées par Firebase </h1>
      <table className='politique-table'>
       
        <thed>
            <tr> <th>Firebase Hosting - Administré par Google</th>
            </tr>
           
        </thed>

      </table>
      <br></br>
      <h2>Explication selon Firebase</h2>
      <table className="politique-table">
        <thead>
          <tr>
            <th>Service</th>
            <th>Type de Données</th>
            <th>Explication</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Firebase Hosting</td>
            <td>Adresses IP</td>
            <td>
              <strong>Comment cela aide :</strong> l'hébergement utilise les adresses IP des demandes reçues pour détecter les abus et fournir aux clients une analyse détaillée des données d'utilisation.<br/>
              <strong>Conservation :</strong> l'hébergement conserve les données IP pendant quelques mois.
            </td>
          </tr>
          
        </tbody>
      </table>
      <br></br>
      <div>
      <h1>Nous nous efforçons de mettre régulièrement à jour les informations proposées sur ce site. 
        <br></br>

 
 </h1>
    <h1>

L’équipe Luxembourg multi-LEARN Institute asbl, 30 avril 2025
    </h1>
      </div>
  

    </div>
    
    </div>
  );
};

export default Politique;
